import React from 'react'
import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import PropTypes from 'prop-types'
import { Article, Title, Excerpt, Category } from './ArticleCard.style'
import Theme from '../../../styles/theme'

const ArticleCard = ({
  title,
  slug,
  category,
  featuredImage,
  body,
}) => (
  <Article>
    <Link to={`/article/${slug}/`}>
      { featuredImage &&
        <Img className="wow fadeInLeft" fluid={featuredImage.imageFile.fluid} backgroundColor={Theme.colors.imageBackground} />
      }
      <Title className="wow fadeIn" data-wow-delay="0.3s">{title}</Title>
      <Excerpt
        className="wow fadeIn"
        data-wow-delay="0.5s"
        dangerouslySetInnerHTML={{
          __html: ((body.childMarkdownRemark || {
          }).html || '').replace(/(<([^>]+)>)/ig, '').substring(0, 110),
        }}
      />
      <Category className="wow fadeIn">{category.title}</Category>
    </Link>
  </Article>
)

ArticleCard.propTypes = {
  slug: PropTypes.string,
  category: PropTypes.shape({
    title: PropTypes.string,
  }).isRequired,
  featuredImage: PropTypes.shape({
    fluid: PropTypes.object,
  }),
  title: PropTypes.string,
  body: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      rawMarkdownBody: PropTypes.string,
    }),
  }),
}

ArticleCard.defaultProps = {
  slug: null,
  featuredImage: null,
  title: null,
  body: null,
}

export const ArticleCardFragment = graphql`
  fragment ArticleCardFragment on ContentfulArticle {
    id
    title
    slug
    categories {
      title
    }
    featuredImage {
      ...FluidImageFragment
    }
    body {
      childMarkdownRemark {
        rawMarkdownBody
        html
      }
    }
  }
`

export default ArticleCard
